import { ServiceTypeEnum } from './enumerations/service-type.enum';
import { SupplierInvoiceSaving } from './supplier-invoice-saving';

export class SupplierInvoiceItem {
  id: number;
  serviceOrderId: string;
  serviceOrderType: ServiceTypeEnum | null = null;
  serviceItemCode: string;
  serviceItemName: string | undefined;
  isIncludingVAT: boolean | undefined;
  isInVATCreditorGroup: boolean;
  quantity: number;
  quantityUnit: string;
  paidAmount: number;
  exchangeRate: number;
  supplierId: number;
  creditorId: string;
  creditorName: string;
  savings: SupplierInvoiceSaving[];
  calculatedFromGross: boolean = false;

  public constructor(init?: Partial<SupplierInvoiceItem>) {
    Object.assign(this, init);
  }
}
